import { BreadcrumbItemType } from "@/components/Breadcrumbs/types"
import { ROUTES } from "@/utils/constants"

export const BREADCRUMB_CATALOG_DEFAULT: Record<string, BreadcrumbItemType> = {
  "1": {
    title: "Каталог",
    path: ROUTES.catalog,
  },
}
